export const acquisition = {
  primary: 'Influencers + Affiliates',
  flow: ['Creators', 'VEXU App', 'New users'],
  proof: 'Affiliate infrastructure already built',
  detail:
    'Creator portal · Attribution · Real-time activations · Commissions · Withdrawals',
  secondary: ['Performance marketing', 'PR / Organic', 'Referrals'],
}

export const exposureLoop = [
  'VEXU user',
  'AI handles the call',
  'Caller experiences VEXU',
  'New user',
]

export const exposureStatement = 'Every answered call creates product exposure.'

export interface BusinessCapability {
  id: 'voice' | 'whatsapp' | 'website' | 'workflows' | 'integrations'
  label: string
  note?: string
}

export const businessCapabilities: BusinessCapability[] = [
  { id: 'voice', label: 'Voice' },
  { id: 'whatsapp', label: 'WhatsApp' },
  { id: 'website', label: 'Website AI', note: 'Chat + Call' },
  { id: 'workflows', label: 'Workflows' },
  { id: 'integrations', label: 'Integrations' },
]

export const businessChannels = [
  'Direct sales',
  'Telecom / channel partners',
  'Technology partners',
]

export const gtmStages = [
  { index: '01', title: 'Acquire' },
  { index: '02', title: 'Expand through the product' },
  { index: '03', title: 'Expand into business' },
]
